import React from 'react';
import { EntitiesArray } from '../components/island';

export class Earning extends React.Component {

  // Calculate the 'production'
  getProductionCapacity(data){
    let Pwrproduction = data.getMwuServices(),
        PwrPurchased = data.purchasedMwu,
        PwrNeeded = data['mwuNecessity'],
        boughtMwu = 0;

    // Loop trough all bought enity mwu's
    if (PwrPurchased.length > 0) {
      for (var i = 0; i < PwrPurchased.length; i++) {
        boughtMwu += PwrPurchased[i]['mwu'];
      }
    }

    // TODO name is incorrect this is the full production
    let pwrSelfProduction = Pwrproduction + boughtMwu;
    let productionCapacity;

    if (pwrSelfProduction <= 0 ) {
      productionCapacity = 0;
    } else {
      productionCapacity = (pwrSelfProduction / PwrNeeded);
    }

    return productionCapacity;
  }

  search(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
      if (myArray[i].name === nameKey) {
        return myArray[i];
      }
    }
  }

  getCompanyEarning = (data) =>  {
    const cityName = data.location;
    const cityData = this.search(cityName, EntitiesArray);
    const cityProduction = cityData.getProduction();

    if (cityProduction < 100) {
      return true;
    } else {
      return false;
    }
  }

  tableMaker(data){
    if (data) {
      if (data.type === 'city') {
        const table = [],
              dataType = data['type'],
              dataFunds = data['funds'],
              dataStartingFunds = data['startingFunds'];

        let newFunds;
        let production = this.getProductionCapacity(data);
        //console.log(data.name, production);

        // Check for company regarding possible penalty
        if (dataType === 'company') {
          if (this.getCompanyEarning(data)) {
            production += -0.1;
          }
        }

        if (production < 0 ) {
          newFunds = 0;
        }

        if (production > 100) {
          production = 100;
        }

        newFunds = dataStartingFunds * production;

        if (newFunds < 0) {
          newFunds = 0;
        }

        let productionPercentage = production * 100;

        if (productionPercentage < 0) {
          productionPercentage = 0;
        }
        if (productionPercentage > 100) {
          productionPercentage = 100;
        }

        const oldFunds = data['funds'];
        data['funds'] += parseInt(newFunds.toFixed(0),10);

        table.push(<div className="addition" key={'income_addition_' + this.props.dataKey}>
          <div className="name">{data['name']}</div>
            <div className="amount">+ &euro;{newFunds.toFixed(0)}</div>
          <div className="prev">Je had nog &euro;{oldFunds.toFixed(0)}</div>
          <div className="calculation">
            Je krijgt erbij &euro;{dataFunds.toFixed(0)} + ( &euro;{dataStartingFunds.toFixed(0)} x {(productionPercentage).toFixed(0)} &#37;) = &euro;{data['funds'].toFixed(0)}
          </div>
          <div className="amount">Nieuwe budget &euro;{data['funds'].toFixed(0)}</div>
        </div>);

        return table;
      } else if(data.type === 'company') {
        const table = [],
              dataType = data['type'],
              dataFunds = data['funds'],
              dataStartingFunds = data['startingFunds'];

        let newFunds;
        let production = this.getProductionCapacity(data);
        //console.log(data.name, production);

        // Check for company regarding possible penalty
        if (dataType === 'company') {
          if (this.getCompanyEarning(data)) {
            production += -0.1;
          }
        }

        if (production < 0 ) {
          newFunds = 0;
        }

        if (production > 100) {
          production = 100;
        }

        newFunds = dataStartingFunds * production;

        if (newFunds < 0) {
          newFunds = 0;
        }

        let productionPercentage = production * 100;

        if (productionPercentage < 0) {
          productionPercentage = 0;
        }
        if (productionPercentage > 100) {
          productionPercentage = 100;
        }

        const oldFunds = data['funds'];
        data['funds'] += parseInt(newFunds.toFixed(0),10);

        const parentProduction = EntitiesArray.filter((current) => { return current.name === data.location })[0].getProduction();
        const oldNecessity = data['mwuNecessity']
        let newNecessity = oldNecessity;
        if( data.getProduction() >= 100 ){
          newNecessity += 2;
        }

        if( parentProduction <= 100 ){
          newNecessity = (newNecessity - (newNecessity * 0.1));
        }

        const productionChangeFactor = (((newNecessity - oldNecessity) / oldNecessity) * 100).toFixed(0);

        console.log(parentProduction, oldNecessity, newNecessity);

        table.push(<div className="addition" key={'income_addition_' + this.props.dataKey}>
          <div className="name">{data['name']}</div>
          <div className="amount">+ &euro;{newFunds.toFixed(0)}</div>
          <div className="prev">Je had nog &euro;{oldFunds.toFixed(0)}</div>
          <div className="prev">Je energievoorziening was {data.getProduction().toFixed(0)}&#37;</div>
          <div className="prev">De energievoorziening in de stad in jouw regio was {parentProduction.toFixed(0)}&#37;</div>
          <div className="prev">Je productie verandert met {productionChangeFactor}&#37;</div>
          <div className="calculation">
            Je krijgt erbij &euro;{dataFunds.toFixed(0)} + ( &euro;{dataStartingFunds.toFixed(0)} x {(productionPercentage).toFixed(0)} &#37;) = &euro;{data['funds'].toFixed(0)}
          </div>
          <div className="amount">Nieuwe budget &euro;{data['funds'].toFixed(0)}</div>
        </div>);

        return table;
      }
    }
  }

  render(){
    return(
      <div className="gameIncome">
        { this.tableMaker(this.props.data) }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/earning.js